import React, { createContext, useEffect, useRef, useState } from 'react';
import ChalanUpdateReturnTabs from './Utilities/ChalanUpdateReturnTabs';
import { Card, Form } from 'react-bootstrap';
import ComponentIdentifier from '../CommonComponent/ComponentHeader/ComponentIdentifier';
import HeaderComponent from '../CommonComponent/ComponentHeader/HeaderComponent';
import { useDispatch } from 'react-redux';
import { getSingleChalanForUpdateAction } from '../../Redux/Action/PurAction';
import { ToastContainer } from 'react-toastify';

// create context
export const ChalanUpdateAndReturnContext = createContext();

function ChalanUpdateAndReturnComponent({ is_stock_return = false, is_transfer = false, component_header_title = 'Chalan update' }) {
  // hooks
  const chalanGetFieldRef = useRef();
  const dispatch = useDispatch();

  // states
  const [newOnClickState, setNewOnClickState] = useState(false);
  const [singleChalanForUpdate, setSingleChalanForUpdate] = useState({});
  const [singleChalanItemForReturn, setSingleChalanItemForReturn] = useState({});

  // new on click lifecycle
  useEffect(() => {
    setSingleChalanForUpdate({});
  }, [newOnClickState]);
  // reset also data by changing updated chalan
  useEffect(() => {
    setSingleChalanItemForReturn({});
  }, [singleChalanForUpdate]);

  const chalanGetForUdpateAndReturnOnSubmit = (e) => {
    e?.preventDefault();
    // making payload for get chalan for update
    const payload = {
      data: { chalan_no: chalanGetFieldRef.current.value },
      chalanGetFieldRef,
      setSingleChalanForUpdate,
    };
    // aciton dispatch
    dispatch(getSingleChalanForUpdateAction(payload));
  };
  return (
    <>
      <ChalanUpdateAndReturnContext.Provider
        value={{
          singleChalanForUpdate,
          setSingleChalanItemForReturn,
          singleChalanItemForReturn,
          setNewOnClickState,
          chalanGetForUdpateAndReturnOnSubmit,
          chalanGetFieldRef,
        }}
      >
        {/*chalan get from db card*/}
        <Card className="mb-3">
          <Card.Header className="d-flex align-items-center justify-content-between">
            <ComponentIdentifier
              link_name={!is_stock_return ? 'Purchase' : 'Store'}
              component_name={component_header_title}
            />
            {HeaderComponent.new([setNewOnClickState])}
          </Card.Header>
          <Card.Body>
            {/*Chalan get form*/}
            <Form onSubmit={(e) => chalanGetForUdpateAndReturnOnSubmit(e)}>
              <Form.Group
                className=" mb-2"
                controlId="formBasicEmail"
              >
                <Form.Control
                  ref={chalanGetFieldRef}
                  type="text"
                  placeholder="Enter chalan no"
                />
              </Form.Group>
            </Form>
          </Card.Body>
        </Card>
        {/*tabs*/}
        <ChalanUpdateReturnTabs
          is_stock_return={is_stock_return}
          is_transfer={is_transfer}
        />
        {/*toast*/}
        <ToastContainer />
      </ChalanUpdateAndReturnContext.Provider>
    </>
  );
}

export default ChalanUpdateAndReturnComponent;
